import { DOMAttributes, PropsWithChildren } from 'react'
import Styles from './Grid.module.scss'
import Masonry from 'react-masonry-css'

interface Props {
  breakpointCols?: number
}

export const Root = (props: PropsWithChildren<Props>) => {
  return (
    <Masonry
      breakpointCols={props.breakpointCols || 4}
      className={Styles.masonryGrid}
      columnClassName={Styles.gridColumn}
      {...props}
    />
  )
}

export const Thumbnail = (props: PropsWithChildren<DOMAttributes<HTMLDivElement>>) => (
  <div>
    <div className={Styles.thumbnail} {...props} />
  </div>
)

export const Grid = {
  Root,
  Thumbnail,
}
